/**
 * Created by Ning Jiang on 11/24/2016.
 */


import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {DungeonQuestParsedGameData} from "../server/data/DungeonQuestParsedGameData";
import {DungeonQuestParsedInitData} from "../server/data/DungeonQuestParsedInitData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";

export class DungeonQuestFreespinZeroBetController extends FreespinZeroBetController {
    constructor() {
        super();
    }

    protected calculateIsTriggered(data: ParsedServerData): boolean {
        const isNextFirstFreespin: boolean = data.freespinTriggeredThisSpin != null ? data.freespinTriggeredThisSpin : false;

        let freespinsLeft: number = 0;
        if (data instanceof DungeonQuestParsedGameData || data instanceof DungeonQuestParsedInitData) {
            freespinsLeft = data.freespinsRemaining != null ? data.freespinsRemaining : 0;
        }

        const isNextContinueFreespin: boolean = (data.mode === GameMode.FREESPIN || data.nextMode === GameMode.FREESPIN) && freespinsLeft > 0;
        return isNextFirstFreespin || isNextContinueFreespin;
    }

    // #91
    protected getZeroBetNumberLeft(data: DungeonQuestParsedGameData): number {
        return data.freespinsRemaining;
    }

    public handleZeroBetCounter():void {
        SlotGame.api.betHandler.zeroBet();
    }
}